// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"6f511798","190":"83048e9d","453":"f75cf731","726":"07b7d9b7"}[chunkId] + ".chunk.js";
};